import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input, InputGroup, InputGroupButton } from 'reactstrap';

const buttonStyle = {
  fontWeight: 'bold'
};

class InputNumber extends Component {
  
    constructor(props) {
      super(props);
  
      this.increaseNumber = this.increaseNumber.bind(this);
      this.decreaseNumber = this.decreaseNumber.bind(this);
      this.handleNumberChange = this.handleNumberChange.bind(this);
    }

    increaseNumber() {
      if (this.props.nValue < this.props.max)
        this.props.onNumberChange(this.props.nValue + 1);
    }
    decreaseNumber() {
      if (this.props.nValue > this.props.min)
        this.props.onNumberChange(this.props.nValue - 1);
    }
    handleNumberChange(e) {
      const num = +e.target.value;
      if (Number.isInteger(num))
        this.props.onNumberChange(num > this.props.max ? this.props.max : e.target.value);
    }    

    render() {
      return (
        <div className={"input-number " + this.props.className}>
          <div className="input-number-tag">{this.props.tag}</div>
          <InputGroup>
            <InputGroupButton style={buttonStyle} onClick={this.decreaseNumber}>-</InputGroupButton>
            <Input value={this.props.nValue} onChange={this.handleNumberChange} />                  
            <InputGroupButton style={buttonStyle} onClick={this.increaseNumber}>+</InputGroupButton>
          </InputGroup>
        </div>
      )
    }
}

InputNumber.propTypes = {
  tag: PropTypes.string,
  nValue: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number  
}

InputNumber.defaultProps = {
  tag: '',
  nValue: 0,
  min: 0,
  max: 0
}

export default InputNumber;


// WEBPACK FOOTER //
// ./src/components/InputNumber.js